import store from "../store";
import axios from "axios";
import { APIService } from "./api";
const apiService = new APIService();

export class APIServiceFeedbackFile {
  getFeedbackFiles(propertyID) {
    var config = {
      url: "/property/" + propertyID + "/feedbackfile",
      method: "get",
      headers: {
        "x-access-token": store.getters.token,
        "content-type": "application/json"
      }
    };
    return apiService.api(config);
  }

  createFeedbackFileUpload(propertyID, fileData) {
    let formData = new FormData();
    formData.append("file", fileData);

    return axios
      .post("/property/" + propertyID + "/fileupload", formData, {
        headers: {
          "x-access-token": store.getters.token,
          "Content-Type": "multipart/form-data"
        }
      })
      .then(response => {
        console.log(response);
        // context.commit('setIsLoadingFileDone', {isLoadingFile: false, isLoadingFileSuccessful: true});
        // context.dispatch('getFeedbackFiles', data1);
        // router.push('/console/dashboard/property/' + data1 + '/feedbackfileupload');
        // console.log('success!!');
      })
      .catch(error => {
        apiService.error(error);
      });
  }
}
